<div class="box flex flex-col full-grow-no-shrink-no-basis">
  <div class="flex flex-row">
    <div class="avatar" *ngIf="!item?.from?.avatar">{{item?.createdBy?.userName[0]}}</div>
    <div class="w-p-100 flex flex-col">
      <div class="flex flex-row justify-between items-center">
        <div class="flex flex-col full-grow-no-shrink-no-basis ">
          <div class="user-name">{{item?.createdBy?.userName}}</div>
          <div class="cc-container m-b-5 flex flex-row">
            <span>to</span>
            <div *ngFor="let m of item.recipients" class="mail-address">
              {{m.email}}
              <span>,</span>
            </div>
          </div>
        </div>
        <!--<div *ngIf="!item.isLastMail">-->
        <!--<button mat-icon-button class="taskAlert-actions-button"-->
        <!--[matMenuTriggerFor]="replyMenu">-->
        <!--<mat-icon class="s-20">more_vert</mat-icon>-->
        <!--</button>-->
        <!--<mat-menu #replyMenu="matMenu">-->
        <!--<div mat-menu-item>-->
        <!--<div *ngIf="!item.IsShowReply" (click)="item.IsShowReply=!item.IsShowReply">Reply</div>-->
        <!--<div *ngIf="item.IsShowReply" (click)="item.IsShowReply=!item.IsShowReply">Cancel Reply</div>-->
        <!--</div>-->
        <!--</mat-menu>-->
        <!--</div>-->
      </div>
      <div class="timing">{{item.createdDate}}</div>
    </div>
  </div>
  <div class="email-content" [innerHTML]="message | sanitizeHtml"></div>

  <!--<div *ngIf="item && item.fileAttachments.length>0">-->
  <!--<div *ngFor="let attachment of item.fileAttachments" fxLayout="column">-->
  <!--<div  fxLayout="row" fxLayoutAlign="space-between center" class="attachment-container">-->
  <!--<a (click)="downloadAttachment(attachment)" class="link-color">{{attachment.attachmentTitle}}</a>-->
  <!--</div>-->
  <!--</div>-->
  <!--</div>-->
  <!--<particle-reply-message (discardMessage)="discardMsg($event)" *ngIf="item.IsShowReply" [mailContent]='item'></particle-reply-message>-->
</div>
